import dashboard from '@/pages/dashboard/_locales/en-US';
import home from '@/pages/home/_locales/en-US';
import intelligence from '@/pages/intelligence/_locales/en-US';
import globalpedia from '@/pages/globalpedia/_locales/en-US';
import opinion from '@/pages/opinion/_locales/en-US'; 
import datalab from '@/pages/datalab/_locales/en-US';
import aigc from '@/pages/aigc/_locales/en-US';
import benchmark from '@/pages/benchmark/_locales/en-US';
import strategic from '@/pages/strategic/_locales/en-US';
import userCenter from '@/pages/user-center/_locales/en-US';

export default {
  ...dashboard,
  ...home,
  ...intelligence,
  ...globalpedia,
  ...opinion, 
  ...datalab,
  ...aigc,
  ...benchmark,
  ...strategic,
  ...userCenter,
};
